import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const domainTools = defineConnector({
  identifier: "domainTools",
  name: "DomainTools",
  tagLine: "Domain and DNS threat intelligence",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.domaintools\\.com/.*",
  auth: (app) =>
    queryAuth([
      { name: "api_username", value: app.config.apiUsername },
      { name: "api_key", value: app.secret.apiKey },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [DomainTools admin portal](https://research.domaintools.com/) and open your account's **API administration** page to find your API username and key. See the [authentication docs](https://docs.domaintools.com/api/iris/authentication/) for details.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API username",
          required: true,
          target: { kind: "configuration", field: "apiUsername" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.domaintools.com/v1/account/",
  },
});
